import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { getBoundingBox } from '@/pages/AdvancedEditor/utils/getBoundingBox';
import { ElementsArray, ElementType, GroupElementType } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

const alignBottom = (element: ElementType, bottomY: number) => {
    const box = getBoundingBox(element);
    const offsetY = box.maxY - element.y;
    element.set({ y: bottomY - offsetY });
};

export function alignElementsBottom(store: StoreType, elements: ElementsArray) {
    const bottomY = elements.length > 1 ? Math.max(...elements.map(getBoundingBox).map(box => box.maxY)) : store.height;

    elements.forEach(element => {
        alignBottom(element, bottomY);

        if (element.type === polotnoTypes.Group) {
            (element as GroupElementType).children.forEach((child: ElementType) => {
                alignBottom(child, bottomY);
            });
        }
    });
}
